import { Formik, Form } from 'formik';
import {
	initialValues,
	validationSchema_FormEdwardsLearningApp,
} from 'blocks/Form/data/validation';
import Submit from 'blocks/Form/fields/Submit';
import FirstName from 'blocks/Form/fields/FirstName';
import LastName from 'blocks/Form/fields/LastName';
import ProfessionalEmail from 'blocks/Form/fields/ProfessionalEmail';
import TherapyOfInterest from 'blocks/Form/fields/TherapyOfInterest';
import LearningAppRole from 'blocks/Form/fields/LearningAppRole';
import LearningAppSpecialty from 'blocks/Form/fields/LearningAppSpecialty';
import LearningAppLocation from 'blocks/Form/fields/LearningAppLocation';
import HospitalName from 'blocks/Form/fields/HospitalName';
import Parse from 'react-html-parser';
import AdditionalInformation from 'blocks/Form/fields/AdditionalInformation';

/* === CORP - Edwards Learning App === */

const FormEdwardsLearningApp = ({ handleSubmit, isPending, language, fields }) => {
	const {
		first_name,
		last_name,
		professional_email_address,
		therapy_of_interest,
		learning_app_role,
		learning_app_specialty,
		hospital_institution,
		learning_app_location,
		hospital_name,
		additional_information,
		edwards_employee,
		register,
		registering,
		validation,
	} = fields;
	return (
		<Formik
			initialValues={initialValues}
			onSubmit={values => handleSubmit('docebo', values)}
			validationSchema={validationSchema_FormEdwardsLearningApp(validation)}
		>
			{formik => (
				<Form className='form form--lg'>
					<div className='grid-md-2 row-gap-0'>
						<FirstName label={first_name} initialValues={initialValues} />
						<LastName label={last_name} initialValues={initialValues} />
						<ProfessionalEmail label={professional_email_address} initialValues={initialValues} />
						<TherapyOfInterest data={therapy_of_interest} initialValues={initialValues} />
						<LearningAppRole data={learning_app_role} initialValues={initialValues} />
						<LearningAppSpecialty data={learning_app_specialty} initialValues={initialValues} />
					</div>
					<p>
						<strong>{hospital_institution}</strong>
					</p>
					<div className='grid-md-2 row-gap-0'>
						<LearningAppLocation
							data={learning_app_location}
							formik={formik}
							initialValues={initialValues}
						/>
						<HospitalName label={hospital_name} initialValues={initialValues} />
					</div>
					<AdditionalInformation data={additional_information} />

					{formik.values.ProfessionalEmailAddress?.includes('edwards.com') && (
						<>{Parse(edwards_employee)}</>
					)}
					{!formik.values.ProfessionalEmailAddress?.includes('edwards.com') && (
						<Submit formik={formik} isPending={isPending} pendingText={registering}>
							{register}
						</Submit>
					)}
				</Form>
			)}
		</Formik>
	);
};

export default FormEdwardsLearningApp;
